import React from "react";
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  "@keyframes fadeInUp": {
    "0%": { opacity: 0, transform: "translateY(20px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  root: {
    height: "100%",
    borderRadius: 16,
    transition:
      "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
    animation: "$fadeInUp 0.45s ease both",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 20px 48px rgba(0, 0, 0, 0.12)",
    },
  },
  content: {
    padding: theme.spacing(3),
    "&:last-child": {
      paddingBottom: theme.spacing(2),
    },
  },
  avatar: {
    background: "linear-gradient(135deg, #E93A24 0%, #ff6a45 100%)",
    height: 56,
    width: 56,
    boxShadow: "0 6px 18px rgba(233, 58, 36, 0.30)",
    "& svg": {
      width: 22,
      height: 22,
    },
  },
  title: {
    textTransform: "uppercase",
    letterSpacing: "0.09em",
    fontSize: "0.68rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    opacity: 0.7,
    marginBottom: theme.spacing(0.75),
  },
  value: {
    fontWeight: 700,
    letterSpacing: "-0.03em",
    lineHeight: 1.1,
    color: theme.palette.text.primary,
  },
  actionWrapper: {
    "& .MuiDivider-root": {
      backgroundColor: "rgba(0, 0, 0, 0.06)",
    },
    "& .MuiButton-root": {
      fontWeight: 600,
      fontSize: "0.75rem",
      letterSpacing: "0.04em",
      "&:hover": {
        backgroundColor: "rgba(233, 58, 36, 0.05)",
      },
    },
  },
}));

const CardDashboard = ({ title, value, avatar, children, action }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <Grid container justify="space-between" spacing={3} alignItems="flex-start">
          <Grid item>
            <Typography className={classes.title} component="p">
              {title}
            </Typography>
            <Typography className={classes.value} variant="h3">
              {value}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>{avatar}</Avatar>
          </Grid>
        </Grid>
        {children}
      </CardContent>
      {action ? <div className={classes.actionWrapper}>{action}</div> : null}
    </Card>
  );
};

export default CardDashboard;
